import { useEffect } from 'react';
import { recordViewVisit } from '../utils/viewCountApi';

export function useRecordView() {
  useEffect(() => {
    recordViewVisit();
  }, []);
}
